import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=0924d1f3&scoped=true&"
import script from "./Btn.vue?vue&type=script&lang=js&"
export * from "./Btn.vue?vue&type=script&lang=js&"
import style0 from "./Btn.vue?vue&type=style&index=0&id=0924d1f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0924d1f3",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Btn.vue
// module id = null
// module chunks = 